<template>
    <div class="container-fluid">
        <div class="row">
            <div class="col-12">
                <div class="card card-blue">
                    <div class="card-header">
                        <div class="d-md-flex align-items-center">
                            <div>
                                <h4 class="card-title">Goods & Services</h4>
                                <h6 class="card-subtitle">List of Goods/Services available for purchase</h6>
                            </div>
                            <div class="ml-auto d-flex no-block align-items-center">
                                <div class="dl">
                                    <div class="button-group">
                                        <router-link :to="{name: 'addsalegoodsservices', params: {expressid: currentOrg.express_id}}" class="btn btn-success waves-effect waves-light">
                                            <i class="fas fa-plus"></i> Add Goods & Services
                                        </router-link>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="card-body collapse show">
                        <div class="form-row">
                            <div class="form-group col-md-12">
                                <div class="input-group">
                                    <input type="text" class="form-control"
                                           placeholder="Search Goods and Services by Name and Description"
                                           v-model="search">
                                    <div class="input-group-append">
                                        <button @click="getGoodsServices(1)" class="btn btn-light btn-outline-success font-weight-bold" type="button">
                                            <i class="fa fa-search"/> Go!
                                        </button>
                                        <button @click="reset()" class="btn btn-light btn-outline-secondary btn-arrange font-weight-bold" type="button">
                                            <i class="fa fa-undo"/> Reset
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="table-responsive" v-if="goodsServices.length > 0">
                            <div class="col-md-12">
                                <div class="form-group row">
                                    <label class="col-form-label p-l-10" for="records">Display</label>
                                    <div class="col-sm-1 p-t-5">
                                        <select @change="perPageRecordChange()" aria-controls="lang_opt" class="form-control form-control-sm" id="records" name="lang_opt_length" v-model="perPage">
                                            <option value="10">10</option>
                                            <option value="25">25</option>
                                            <option value="50">50</option>
                                            <option value="100">100</option>
                                        </select>
                                    </div>
                                    <label class="col-form-label" for="records">Records per page</label>

                                    <div class="ml-auto">
                                        <span class="fa-xs fa-stack fa-1x ml-auto m-r-10 text-muted" v-if="exporting" title="Exporting, please wait ...">
                                          <i class="fa fa-circle-notch fa-stack-2x fa-spin"></i>
                                          <i class="fa fa-xs fa-file-excel fa-stack-1x"></i>
                                        </span>
                                        <div class="btn-group">
                                            <button aria-expanded="false" aria-haspopup="true" class="btn waves-effect waves-light btn-outline-info dropdown-toggle" data-toggle="dropdown"
                                                    type="button">
                                                Operations
                                            </button>
                                            <div class="dropdown-menu">
                                                <a @click="exportGSAsExcel()" class="dropdown-item" href="javascript:void(0)">
                                                    <i class="fa fa-file-excel"/> Export
                                                </a>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <table class="table no-wrap v-middle">
                                <thead>
                                <tr class="border-0 bg-light">
                                    <th class="border-0"><h6>Name</h6></th>
                                    <th class="border-0"><h6>Description</h6></th>
                                    <th class="border-0"><h6>Properties</h6></th>
                                    <th class="border-0"><h6>Current Rate</h6></th>
                                    <th class="border-0"><h6>Action</h6></th>
                                </tr>
                                </thead>
                                <tbody>
                                <tr v-bind:key="index" v-for="(gs, index) in goodsServices">
                                    <td>{{gs.name}}</td>
                                    <td>{{gs.description?gs.description:"N/A" | truncate(50, '...')}}</td>
                                    <td>
                                        <ul v-if="gs.goods_services_props.length > 0">
                                            <li v-bind:key="index" v-for="(gsp, index) in gs.goods_services_props">
                                                {{gsp.value}}
                                            </li>
                                        </ul>
                                        <span v-else>N/A</span>
                                    </td>
                                    <td v-if="gs.rate.amount">{{gs.rate | money}}/{{gs.unit.symbol}}</td>
                                    <td v-if="!gs.rate.amount">{{ 'N/A' }}</td>
                                    <td>
                                        <a @click="viewGoodsServices(gs.id)" href="javascript:void(0)">
                                            <h6>View & Edit</h6>
                                        </a>
                                    </td>
                                </tr>
                                </tbody>
                            </table>
                        </div>
                        <template v-else>
                            <h4 class="card-title text-muted text-center m-t-30">No records found.</h4>
                            <h5 class="card-title text-muted text-center m-b-30">Change search criteria and try again</h5>
                        </template>
                    </div>
                </div>
            </div>
        </div>
        <div class="row" v-if="goodsServices.length > 0">
            <div class="col-12">
                <paginate
                        :click-handler="pageHandler"
                        :container-class="'pagination float-right'"
                        :margin-pages="2"
                        :next-class="'page-link'"
                        :next-text="'Next'"
                        :page-class="'page-link'"
                        :page-count=pageCount
                        :page-range="3"
                        :prev-class="'page-link'"
                        :prev-text="'Prev'">
                </paginate>
            </div>
        </div>
    </div>
</template>

<script>
    import {mapGetters} from "vuex";
    import Paginate from 'vuejs-paginate';
    import moment from "moment";
    import XLSX from "xlsx";

    export default {
        name: "ViewSaleGoodsServices",
        components: {Paginate},
        computed: {
            ...mapGetters(["currentUser", "currentOrg"])
        },
        data() {
            return {
                goodsServices: [],
                pageCount: 1,
                total: 0,
                perPage: 10,
                search: null,
                exporting: false
            }
        },
        mounted() {
            this.init();
        },
        methods: {
            async init() {
                await this.getGoodsServices(1);
            },
            async getGoodsServices(page) {
                try {
                    $(".preloader").fadeIn();
                    let reply = await this.$http
                    .get(`/express/${this.currentOrg.express_id}/sales/goodsservices`, {
                        params: {
                            page: page,
                            perPage: this.perPage,
                            search: this.search
                        }
                    });
                    $(".preloader").fadeOut();
                    this.total         = reply.data.total;
                    this.goodsServices = reply.data.goodsAndServices;
                    this.setPageCount();
                } catch(e) {
                    $(".preloader").fadeOut();
                }
            },
            pageHandler(pageNum) {
                this.getGoodsServices(pageNum);
            },
            setPageCount() {
                this.pageCount = this.total <= this.perPage ? 1 : Math.ceil(this.total / this.perPage);
            },
            viewGoodsServices(goodsservicesid) {
                this.$router.push({name: "viewsalegoodsservices", params: {goodsservicesid: goodsservicesid}});
            },
            async reset() {
                this.search =null;
                await this.getGoodsServices()
            },
            perPageRecordChange() {
                if(this.isFiltered) {
                    this.getGoodsServices(1);
                } else {
                    this.getGoodsServices(1);
                }
            },
            async exportGSAsExcel(){
                try {
                    this.exporting = true;

                    let reply = await this.$http
                    .get(`/express/${this.currentOrg.express_id}/sales/goodsservices`, {
                        params: {
                            page: 1,
                            perPage: this.total,
                            search: this.search
                        }
                    });
                    let data       = reply.data.goodsAndServices;
                    let goodsAndServices  = [];
                    data.forEach(d => {
                        goodsAndServices.push({
                            "ID": d.id,
                            "Name": d.name,
                            "Description": d.description,
                            "Measuring Unit": d.unit.symbol,
                            "Rate": `${d.rate.currency_symbol} ${d.rate.amount}/${d.unit.symbol}`
                            })
                    });

                    let workbook  = XLSX.utils.book_new();
                    let worksheet = XLSX.utils.json_to_sheet(goodsAndServices);
                    XLSX.utils.book_append_sheet(workbook, worksheet, 'GoodsAndServices');
                    XLSX.writeFile(workbook, 'goodsAndServices.xlsx');
                } catch(e) {
                    console.error(e)
                    this.$toastr('error', 'Export failed', 'Failure');
                } finally {
                    this.exporting = false;
                }
            }
        }
    }
</script>

<style scoped>

</style>
